import React from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import logo from "../../assets/images/logo.png";
import { updateUserInfo } from "../../services/updateProfileInfo";
import { handleCookies } from "../../utils/cookies";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";

import { FaSignOutAlt } from "react-icons/fa";

function Header() {
  const navigate = useNavigate();
  const activeLink = window.location.pathname.split("/")[1];

  const currentUserData = handleCookies.fetchCookies();

  const handleLogout = async () => {
    const response = await updateUserInfo.signOut();
    if (response.status === "Success") {
      handleCookies.deleteCookies();
     navigate("/signin");
    }
  };

  return (
    <>
      {" "}
      <header className="header-background">
        <Container className="p-0">
          <Navbar className="navbar" id="navbar">
            <Container className="p-o m-0 nav-mobile-container-header">
              <Navbar.Brand
                className="brand-mobile-container"
                onClick={() => navigate("/")}
              >
                <img alt="" src={logo} />
              </Navbar.Brand>
            </Container>
            <Container
              id="center-nav-links"
            >
              <Link
                className={`nav-link ${activeLink == "claims" || activeLink == "unassigned-claims" ? "active" : ""}`}
                to="/claims"
              >
                Insurance Claims
              </Link>
              <Link
                className={`nav-link ${activeLink === "policies" ? "active" : ""}`}
                to="/policies"
              >
                Policies
              </Link>
              {currentUserData.user_role === "Admin" ? (
                <Link
                  className={`nav-link ${activeLink === "users" ? "active" : ""}`}
                  to="/users"
                >
                  Users
                </Link>
              ) : null}
              {currentUserData.user_role === "Admin" ? (
                <Link
                  className={`nav-link ${activeLink === "law-firms" ? "active" : ""}`}
                  to="/law-firms"
                >
                  Law Firms
                </Link>
              ) : null}
            </Container>
            <Container className="justify-content-end">
              {/* <Nav.Link className="px-3" onClick={() => handleLogout()}> */}
                <Button
                  variant="outlined"
                  id="logout-btn"
                  onClick={handleLogout}
                >
                  Logout
                  <FaSignOutAlt />
                </Button>
              {/* </Nav.Link> */}
            </Container>
          </Navbar>
        </Container>
      </header>{" "}
    </>
  );
}

export default Header;
